import { configureStore } from "@reduxjs/toolkit";
import { userExperienceFlagsApi } from "EmployerApplication/api";
import { reducer as formReducer } from "redux-form";

import { abTestReducer } from "Common/abTestUtils/redux";
import { siteConfigSlice } from "Common/Redux/siteConfig";

import { borApplicationApi } from "./api";

export const reducerSlices = {
  form: formReducer,
  abTests: abTestReducer,
  [siteConfigSlice.name]: siteConfigSlice.reducer,
  [borApplicationApi.reducerPath]: borApplicationApi.reducer,
  [userExperienceFlagsApi.reducerPath]: userExperienceFlagsApi.reducer,
};

export const createStore = (preloadedState) => {
  const store = configureStore({
    reducer: reducerSlices,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(borApplicationApi.middleware).concat(userExperienceFlagsApi.middleware),
    preloadedState,
  });

  return store;
};
